export enum RANGE_VIEW_MODE {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}
